<template>
  <el-dialog :visible.sync="visible" :title="answerDetail?.title || '详情'" width="50%" @close="closeDialog">
    <div v-if="answerDetail" style="max-height: 500px; overflow-y: auto">
      <div class="answer-content" v-html="answerDetail.content"></div>
    </div>
    <template #footer>
      <el-button @click="visible = false">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import API from '@/api'
import Store from '@/store'
import { Message } from 'element-ui'

const answerDetail = ref(null)
const appConfig = ref(Store.state.app.appConfig)

const visible = ref(false)

function fetchDetail(id) {
  const submitData = {
    PortalContentSearch: { school_id: appConfig.value.school_id, catid: 423, id }
  }
  API.getNoticeList(submitData).then(res => {
    if (+res.code === 200) {
      answerDetail.value = res.data.list[0]
      visible.value = true
    } else {
      Message.error(res.msg)
    }
  })
}

const open = id => {
  fetchDetail(id)
}

defineExpose({
  open
})

const closeDialog = () => {
  answerDetail.value = null
}
</script>

<style scoped>
.answer-content {
  min-height: 120px;
  font-size: 15px;
  color: #333;
  line-height: 1.7;
  word-break: break-all;
  :deep(img) {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 10px 0;
  }
}
</style>
